<template>
    <div id="app">
        <div class="header">
            <div class="logo_img" @click="logoClick">
                <div style="display:flex; align-items: center; float:left; height: 65px;">
                    <div class="header-logo">
                        <img id="header-img" src="../../static/other/logo.png">
                    </div>
                </div>
                <div style="display:flex; float:left; height: 65px;">
                    <div class="header-important">
                        <div class="company_name">聚泰科技</div>
                        <div class="header-title company_name">gpsoft.com.cn</div>
                    </div>
                </div>
            </div>
            <div id="menu_index">
                <el-menu v-if="seen" :default-active="activeIndex" class="el-menu-demo" menu-trigger="click"
                    text-color="#333" style="height: 65px; border:0;" mode="horizontal" @select="handleSelect">
                    <el-menu-item index="1" class="header-title">首页</el-menu-item>
                    <el-menu-item index="2" class="header-title">产品与服务</el-menu-item>
                    <el-submenu index="3" class="header-title">
                        <template slot="title">
                            <div class="header-title">解决方案</div>
                        </template>
                        <el-menu-item index="3-1" @click="toProductWeb">汽车门店销售管理系统</el-menu-item>
                        <el-menu-item index="3-1" @click="toAfterSalesWeb">汽车售后维修管理系统</el-menu-item>
                        <el-menu-item index="3-2">充电桩</el-menu-item>
                    </el-submenu>
                    <el-menu-item index="4" class="header-title">合作伙伴</el-menu-item>
                    <el-menu-item index="5" class="header-title">关于我们</el-menu-item>
                </el-menu>
                <el-menu v-if="!seen" :default-active="activeIndex" class="el-menu-demo" menu-trigger="click"
                    text-color="#333" style="height: 65px; border:0;" mode="horizontal" @select="handleSelectMobile">
                    <el-submenu index="1" class="header-title mobile_menu">
                        <template slot="title">{{ currentMenu }}</template>
                        <el-menu-item index="1" class="header-title">首页</el-menu-item>
                        <el-menu-item index="2" class="header-title">产品与服务</el-menu-item>
                        <el-menu-item index="3-1" class="header-title">汽车销售集团</el-menu-item>
                        <el-menu-item index="3-2" class="header-title">充电桩</el-menu-item>
                        <el-menu-item index="4" class="header-title">合作伙伴</el-menu-item>
                        <el-menu-item index="5" class="header-title">关于我们</el-menu-item>
                    </el-submenu>
                </el-menu>
            </div>
        </div>
        <div class="container" style="clear: both;">
            <router-view></router-view>
        </div>

        <div style="width: 90%;margin: 20px auto;">
            <div style="height:1px;padding:0;background-color:#999;">
            </div>
        </div>
        <div style="width: 90%;margin: 20px auto;">
            <el-row>
                <el-col :xs="24" :sm="18">
                    <p class="footer_font">地址: 郑州市高新技术开发区瑞达路96号创业中心2号楼B627</p>
                    <p class="footer_font">邮箱: huangwen@gpsoft.com.cn</p>
                    <div style="margin: auto;" class="footer_font">
                        <a href="https://beian.miit.gov.cn">互联网ICP备案：豫ICP备2021016865号</a>
                    </div>
                    <div style="margin: auto;" class="footer_font">
                        ©gpsoft.com.cn 郑州聚泰科技有限公司版权所有
                    </div>
                </el-col>
                <el-col :xs="24" :sm="6" style="display: flex;justify-content: space-evenly;">
                    <div style="border-radius: 5px;">
                        <img :src="require('../../static/footer/1.png')" style="width: 100px;height: 100px;border: 0" />
                    </div>
                    <div style="border-radius: 5px;">
                        <img :src="require('../../static/footer/2.png')" style="width: 100px;height: 100px;border: 0" />
                    </div>
                    <!-- <div class="footer_font">关注聚泰科技公众号</div> -->
                </el-col>
            </el-row>
        </div>
        <div id="back_to_top" ref="btn">
            <div class="tupian" @mouseenter="showHiddenWechatDiv" @mouseleave="hideHiddenWechatDiv"
                style="border-radius: 50%; background-color: white;">
                <img src="../../static/slider/wechat.png" style="height: 40px;width: 40px;padding: 8px;" />
            </div>
            <div class="tanchu" v-show="isHiddenWechatVisible">
                <div class="text">
                    <p>
                        <img decoding="async" class="alignnone size-full wp-image-6552"
                            src="../../static/footer/weixin.jpg" alt="" width="100">
                    </p>
                </div>
            </div>
            <div class="tupian" @mouseenter="showHiddenPhoneDiv" @mouseleave="hideHiddenPhoneDiv"
                style="border-radius: 50%;margin-top: 10px; background-color: white;">
                <img src="../../static/slider/phone.png" style="height: 40px;width: 40px;padding: 8px;" />
            </div>
            <div class="tanchu2" v-show="isHiddenPhoneVisible">
                <div class="text">
                    <h4>24小时咨询热线：</h4>
                    <p>17839990272</p>
                    <div class="arrow">
                        <span class="icono-play"></span>
                    </div>
                </div>
            </div>
            <div style="border-radius: 50%;margin-top: 10px; background-color: white;" @click="backTop">
                <img src="../../static/slider/top.png" style="height: 40px;width: 40px;padding: 8px;" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Layout",
    data() {
        return {
            activeIndex: '1',
            company: {
                // qrcode: require("../../static/other/公众号二维码.jpg"),
            },
            scroll: '',
            timer: '',
            seen: true,
            currentMenu: '首页',
            isHiddenWechatVisible: false,
            isHiddenPhoneVisible: false,
        };
    },
    methods: {
        handleSelect(key) {
            switch (key) {
                case '1':
                    this.$router.push({ name: "Index" });
                    break;
                // case '3-1':
                //     this.$router.push({ name: "Mysales" });
                //     break;
                // case '3-2':
                //     this.$router.push({ name: "NewOrder" });
                //     break;
                // case '3-3':
                //     this.$router.push({ name: "YaoXing" });
                //     break;
                // case '3-4':
                //     this.$router.push({ name: "Finance" });
                //     break;
                case '2':
                    this.$router.push({ name: "Index" });
                    window.location.hash = "#产品与服务";
                    break;
                case '4':
                    this.$router.push({ name: "Index" });
                    window.location.hash = "#合作伙伴";
                    break;
                case '5':
                    this.$router.push({ name: "Index" });
                    window.location.hash = "#关于我们";
                    break;
                default:
                    this.$router.push({ name: "Index" });
                    window.location.hash = "#";
                    break;
            }
        },
        handleSelectMobile(key) {
            switch (key) {
                case '1':
                    this.$router.push({ name: "Index" });
                    break;
                // case '3-1':
                //     this.$router.push({ name: "Mysales" });
                //     break;
                // case '3-2':
                //     this.$router.push({ name: "NewOrder" });
                //     break;
                // case '3-3':
                //     this.$router.push({ name: "YaoXing" });
                //     break;
                // case '3-4':
                //     this.$router.push({ name: "Finance" });
                //     break;
                case '2':
                    this.$router.push({ name: "Index" });
                    window.location.hash = "#产品与服务";
                    this.currentMenu = '首页';
                    break;
                case '4':
                    this.$router.push({ name: "Index" });
                    window.location.hash = "#合作伙伴";
                    this.currentMenu = '首页';
                    break;
                case '5':
                    this.$router.push({ name: "Index" });
                    window.location.hash = "#关于我们";
                    this.currentMenu = '首页';
                    break;
                default:
                    this.$router.push({ name: "Index" });
                    this.currentMenu = '首页';
                    break;
            }
        },
        handleScroll() {
            // this.scroll = document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
            // if (this.scroll > 600) {  //判断滚动后高度超过400px,就显示
            //     this.$refs.btn.style.display = 'block';
            // } else {
            //     this.$refs.btn.style.display = 'none'
            // }
        },
        backTop() { //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
            this.timer = setInterval(() => {
                let osTop = document.documentElement.scrollTop || document.body.scrollTop;
                let ispeed = Math.floor(-osTop / 5)
                document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
                if (osTop === 0) {
                    clearInterval(this.timer)
                }
            }, 30)
        },
        login() {
            window.open('https://admin.fastice-tech.com/login')
        },
        register() {
            window.open('https://admin.fastice-tech.com/registe')
        },
        menuSeen() {
            // 屏幕尺寸
            let screenHeight = document.body.clientWidth;
            if (screenHeight > 415) {
                this.seen = true;
            } else {
                this.seen = false;
            }
        },
        logoClick() {
            this.$router.push({ name: "Index" });
            this.currentMenu = '首页';
        },
        showHiddenWechatDiv() {
            this.isHiddenWechatVisible = true;
        },
        hideHiddenWechatDiv() {
            this.isHiddenWechatVisible = false;
        },
        showHiddenPhoneDiv() {
            this.isHiddenPhoneVisible = true;
        },
        hideHiddenPhoneDiv() {
            this.isHiddenPhoneVisible = false;
        },
        toProductWeb() {
            window.open('http://product.jutaiyun.cn','_black')
        },
        toAfterSalesWeb() {
            window.open('http://service.jutaiyun.cn','_black')
        },
    },
    created() {
        this.$router.push({ name: "Index" });
        this.currentMenu = '首页';
        this.backTop()
    },
    mounted() {
        this.menuSeen()
        window.addEventListener('scroll', this.handleScroll)
    },
}
</script>
<style>
/* 重写element-ui部分样式 */
.el-submenu__title {
    font-size: 1em;
}
</style>
<style scoped>
.logo_img {
    float: left;
    width: 30%;
    cursor: pointer;
}

#back_to_top {
    z-index: 2;
    position: fixed;
    top: 50%;
    right: 30px;
    cursor: pointer
}

.header-title {
    font-size: 1em !important;
}

.company_name {
    font-weight: normal;
    font-size: 1em;
}

.footer_font {
    font-size: 1em;
}

#menu_index {
    float: left;
    width: 50%;
    height: 100%
}

.header {
    margin: auto;
    width: 90%;
    height: 65px;
    /*background: #F56C6C;*/
}

@media screen and (max-device-width: 415px) {
    .logo_img {
        float: left;
        width: auto;
        cursor: pointer;
    }

    #back_to_top {
        position: fixed;
        bottom: 50px;
        right: 5px;
        cursor: pointer
    }

    .footer_font {
        font-size: 0.875em;
    }

    #menu_index {
        float: right;
        width: auto;
        height: 100%
    }

    .mobile_menu {}
}

#header-img {
    width: 50px;
    height: 50px;
    float: left;
    margin: auto;
}

.header-logo {
    height: 50px;
    width: 50px;
    align-self: center;
}

.header-important {
    float: left;
    margin-left: 6px;
    align-self: center;
}

.footer {
    display: flex;
    align-items: center;
    margin: 10px auto;
    width: 90%;
}

a {
    text-decoration: none;
}

a:visited {
    text-decoration: none;
}

a:hover {
    text-decoration: none;
}

a:active {
    text-decoration: none;
}

/* 如果是scoped样式，可能需要使用深度选择器 */
.el-submenu /deep/ .el-submenu__title {
    width: fit-content;
    min-width: 100px;
    display: flex;
    align-items: center;
}

.el-submenu /deep/ .el-submenu__icon-arrow {
    margin-left: 5px;
    vertical-align: middle;
}

.tanchu {
    border-radius: 6px;
    background-color: white;
    position: absolute;
    right: 80px;
    top: 20%;
    white-space: nowrap;
    transform: translate(0px, -50%);
}

.tanchu .text {
    position: relative;
    padding: 0px 30px;
    border-radius: 6px;
}

.tanchu .text .arrow {
    position: absolute;
    right: 0;
    right: -20px;
    top: 50%;
    transform: translate(0, -50%);
}


.tanchu2 {
    border-radius: 6px;
    background-color: white;
    position: absolute;
    right: 80px;
    top: 50%;
    white-space: nowrap;
    transform: translate(0px, -50%);
}

.tanchu2 .text {
    position: relative;
    padding: 0px 30px;
    border-radius: 6px;
}

.tanchu2 .text .arrow {
    position: absolute;
    right: 0;
    right: -20px;
    top: 50%;
    transform: translate(0, -50%);
}


.tanchu2 .text h4 {
    color: #009AFF;font-weight: bold;
}
</style>